import {formDataPost} from "$lib/api";
import {currentProject} from "$lib/stores/projectWizard";
import {currentCustomer} from "$lib/stores/customer";
import {timelineItemForFileUpload} from "$lib/calls/timeline";

let customerUUID:string;
currentCustomer.subscribe(val => {
    if(val && typeof val.uuid !== 'undefined'){
        customerUUID = val.uuid;
    }
})

let project: Project;
currentProject.subscribe(val => {
    if(val){
        project = val;
    }
})
export const storeFiles = async ( newFiles: Array<any>) => {
    const results = [];

    if(typeof project.uuid !== 'undefined'){
        for(let i = 0; i < newFiles.length; i++){
            try{
                const res = await formDataPost("/document/" + customerUUID, {
                    file: newFiles[i],
                    name: newFiles[i].name,
                    projectUuid: project.uuid
                })
                results.push(res);
                await timelineItemForFileUpload(project, newFiles[i].name);
            } catch (e) {
                console.error(e)
            }
        }

    }

    console.log(results);

    return results;
}
export const storeEmployeePicture = async (blob: Blob, employeeUUID: string) => {
    return await formDataPost("/employee/" + employeeUUID + "/avatar", {
        file: blob,
    })

}
export const storeCustomerLogo = async (blob: Blob, customerUUID: string) => {
    return await formDataPost("/customer/" + customerUUID + "/avatar", {
        file: blob,
    })

}
export const storeEmployeeImage = async (blob: Blob, tag:string, employeeUUID: string, documentNumber: null|string = null, name:null|string = null) => {
    return await formDataPost("/employee/" + employeeUUID + "/image", {
        image: blob,
        imageTag:tag,
        name,
        documentNumber
    })
}